import React from "react";
import { LEAD_STATUSES, DELIVERY_STATUSES } from "./leadsConstants";

/** Compact label + <select> row used repeatedly in the filter grid. */
function SelectRow({ label, value, onChange, testId, children }) {
  return (
    <div>
      <label className="label-mono">{label}</label>
      <select data-testid={testId} className="w-full border border-black px-2 py-1.5 mt-1"
        value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="">Any</option>
        {children}
      </select>
    </div>
  );
}

/**
 * The main filter grid (status / delivery / client / affiliate / state /
 * test-prod). Renders 4 or 6 columns depending on whether client/affiliate
 * are shown (i.e. internal users see all 6, clients/affiliates see 4).
 */
export default function LeadsFilterGrid({
  status, setStatus, deliveryStatus, setDeliveryStatus,
  clientId, setClientId, affiliateId, setAffiliateId,
  state, setState, isTest, setIsTest,
  deliveredTo, setDeliveredTo, landingPage, setLandingPage,
  clients, affiliates, isInternal,
}) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">
      <SelectRow label="Status" value={status} onChange={setStatus} testId="filter-status">
        {LEAD_STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
      </SelectRow>
      <SelectRow label="Delivery" value={deliveryStatus} onChange={setDeliveryStatus} testId="filter-delivery">
        {DELIVERY_STATUSES.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
      </SelectRow>
      {isInternal && setDeliveredTo && (
        <SelectRow label="Went to buyer" value={deliveredTo} onChange={setDeliveredTo} testId="filter-delivered-to">
          {clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </SelectRow>
      )}
      {isInternal && setLandingPage && (
        <div>
          <label className="label-mono">Landing page</label>
          <input data-testid="filter-landing-page" placeholder="page address, e.g. quiz"
            className="w-full border border-black px-2 py-1.5 mt-1 lowercase"
            value={landingPage} onChange={(e) => setLandingPage(e.target.value)} />
        </div>
      )}
      {isInternal && (
        <SelectRow label="Client" value={clientId} onChange={setClientId} testId="filter-client">
          {clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </SelectRow>
      )}
      {isInternal && (
        <SelectRow label="Affiliate" value={affiliateId} onChange={setAffiliateId} testId="filter-affiliate">
          {affiliates.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </SelectRow>
      )}
      <div>
        <label className="label-mono">State</label>
        <input data-testid="filter-state"
          className="w-full border border-black px-2 py-1.5 mt-1 uppercase"
          value={state} onChange={(e) => setState(e.target.value)}
          maxLength={2} />
      </div>
      <SelectRow label="Test / Prod" value={isTest} onChange={setIsTest} testId="filter-test">
        <option value="true">Test</option>
        <option value="false">Production</option>
      </SelectRow>
    </div>
  );
}
